package com.macrofocus.eflux

import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.common.properties.SimpleProperty
import com.macrofocus.common.selection.MutableSelection
import com.macrofocus.common.selection.MutableSingleSelection
import com.macrofocus.common.selection.SimpleSelection
import com.macrofocus.common.selection.SimpleSingleSelection
import com.macrofocus.eflux.network.coordinate.Coordinate
import com.macrofocus.eflux.network.logical.LogicalBranchId
import com.macrofocus.eflux.network.logical.LogicalBusId
import com.macrofocus.eflux.network.risk.RiskComponent
import com.macrofocus.eflux.network.schema.Schema

abstract class AbstractEFluxController(configuration: EFluxConfiguration) : EFluxController {
    override val primaryLogicalBusProbing: MutableSingleSelection<LogicalBusId> = configuration.logicalBusProbing
    override val primaryLogicalBranchProbing: MutableSingleSelection<LogicalBranchId> = configuration.logicalBranchProbing
    override val primaryRiskComponentProbing: MutableSingleSelection<RiskComponent> = SimpleSingleSelection<RiskComponent>().apply {
        isEnabled = false
    }
    override val primaryCoordinateProbing: MutableSingleSelection<Coordinate> = SimpleSingleSelection()
    override val primarySchemaProbing: MutableSingleSelection<Schema> = SimpleSingleSelection()

    override val primaryLogicalBusSelection: MutableSelection<LogicalBusId> = configuration.logicalBusSelection
    override val primaryLogicalBranchSelection: MutableSelection<LogicalBranchId> = configuration.logicalBranchSelection
    override val primaryRiskComponentSelection: MutableSelection<RiskComponent> = SimpleSelection<RiskComponent>().apply {
        isEnabled = false
    }
    override val primaryCoordinateSelection: MutableSelection<Coordinate> = SimpleSelection()
    override val primarySchemaSelection: MutableSelection<Schema> = SimpleSelection()

    override val primaryProbing: MutableSingleSelection<Any> = SimpleSingleSelection()
    override val primarySelection: MutableSingleSelection<Any> = SimpleSingleSelection()

    override val secondaryProbing: MutableSingleSelection<Any> = SimpleSingleSelection()
    override val secondarySelection: MutableSingleSelection<Any> = SimpleSingleSelection()

    override val secondary: MutableProperty<Boolean> = SimpleProperty(false)

    init {
        primaryProbing.addSingleSelectionListener { event ->
            println("Primary probing changed to ${event.currentSelection}")
        }
        secondaryProbing.addSingleSelectionListener { event ->
            println("Secondary probing changed to ${event.currentSelection}")
        }

        primarySelection.addSelectionListener { event ->
            println("Primary selection changed to ${event.selected.joinToString { it.toString() }}")
        }
        secondarySelection.addSelectionListener { event ->
            println("Secondary selection changed to ${event.selected.joinToString { it.toString() }}")
        }
    }
}
